import { render } from "./ScanCard.vue?vue&type=template&id=64698dc7"
import script from "./ScanCard.vue?vue&type=script&lang=js"
export * from "./ScanCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\cardscan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__